<template>
  <div class="personal-info-form">
    <personal-info-field
      class="field margin-bottom-l"
      :label="'שם פרטי'"
      :field-name="personalInfoFields.firstName"
      :initialValue="initialValues.firstName"
      :isValid="value => value.length >= 2"
    />
    <personal-info-field
      class="field margin-bottom-l"
      :label="'שם משפחה'"
      :field-name="personalInfoFields.lastName"
      :initialValue="initialValues.lastName"
      :isValid="value => value.length >= 2"
    />
    <personal-info-field
      class="field margin-bottom-l"
      :label="'מס׳ נייד'"
      :field-name="personalInfoFields.phoneNumber"
      :initialValue="initialValues.phoneNumber"
      :isValid="value => value.length >= 10"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PersonalInfoField from '../../../subscription/components/PersonalInfoField.vue';

export default {
  name: 'PersonalInfoForm',
  components: {
    PersonalInfoField,
  },
  data() {
    return {
      personalInfoFields: {
        firstName: 'payerFirstName',
        lastName: 'payerLastName',
        phoneNumber: 'payerPhone',
      },
    };
  },
  computed: {
    // The customer can set a payer that isn't the primary member - prefill with whoever the invoice is made out to,
    // so a name they updated here before shows up instead of the member's name.
    ...mapGetters('subscription', { initialValues: 'invoiceOwner' }),
  },
};
</script>

<style scoped lang="scss">
  .personal-info-form {
    padding-top: 10px;
  }

</style>
